import { Col, Form, Row } from "react-bootstrap";
import React, { useState, useEffect } from 'react'
import { getClientDetails, saveClient, updateClient } from "../api/clientsAPI";
import { ClientDto } from "../types";
import { useTranslation } from "react-i18next";
import AlertMessage from "../../../../components/AlertMessage";
import { GenericSaveButton } from "../../../../components/common/GenericSaveButton";
import { useNavigate, useParams } from 'react-router-dom';
import { RouteNavigationService } from "../../../../utils/navegation/RouteNavegationService";
import { useAlert } from "../../../../hooks/useAlert";

export default function NewClient() {
    const [direccio, setDireccio] = useState<string>('');
    const [typedireccio, setTypeDireccio] = useState<string>('');
    const [raoSocial, setRaoSocial] = useState<string>('');
    const [idClient, setIdClient] = useState<string>('');
    const [name, setName] = useState<string>('');
    const [documentNumber, setDocumentNumber] = useState<string>('');
    const [cp, setCp] = useState<string>('');
    const [municipi, setMunicipi] = useState<string>('');
    const [provincia, setProvincia] = useState<string>(''); 
    const [country, setCountry] = useState<string>(''); 
    const [carreg, setCarreg] = useState<string>(''); 
    const [nameContactPerson, setNameContactPerson] = useState<string>('');
    const [phoneContactPerson, setPhoneContactPerson] = useState<string>('');
    const [emailContactPerson, setEmailContactPerson] = useState<string>('');
    const [socialNetwork, setSocialNetwork] = useState<string>('');
    const [linkSocialNetwork, setLinkSocialNetwork] = useState<string>('');

    const [errors, setErrors] = useState<{ name?: string, phone?: string, email?: string }>({});
    const [loading, setLoading] = useState(false);
   
    const { alert, hideAlert, showAlert, isVisible } = useAlert({ fromLocation: false });

    const { t } = useTranslation();
    const navigate = useNavigate();

    const { id } = useParams();
    const isEdit = Boolean(id);


    useEffect(() => {
        const fetchClient = async () => {
            if (isEdit && id) {
                try {
                    const client = await getClientDetails(Number(id));
                    
                    setIdClient(id || '');
                    setName(client.name || '');
                    setRaoSocial(client.socialReason || '');
                    setDocumentNumber(client.documentNumber || '');
                    setDireccio(client.address || '');
                    setTypeDireccio(client.addressType || '');
                    setMunicipi(client.city || '');
                    setCountry(client.country || '');
                    setCp(client.postCode || '');
                    setCarreg(client.positionJob || '');
                    setNameContactPerson(client.contactName || '');
                    setPhoneContactPerson(client.phoneNumber || '');
                    setEmailContactPerson(client.email || '');
                    setSocialNetwork(client.socialNetwork || '');
                    setLinkSocialNetwork(client.linkSocialNetwork || '');
                } catch (error) {
                    console.error("Error fetching client details:", error);
                    showAlert({
                        message: t("ErrorLoadingClient"),
                        type: "danger",
                        duration: 5000,
                    });
                }
            }
        };
        fetchClient();
    }, [id, isEdit]);


    const handleSubmit = async (e?: React.FormEvent) => {
        e?.preventDefault();
        const body: ClientDto = {
            id: id ? Number(id) : 0,
            name: name,
            socialReason: raoSocial,
            documentNumber: documentNumber,
            contactInfo: nameContactPerson,
            contactType: "ContactType",
            contactName: nameContactPerson,
            positionJob: carreg,
            phoneNumber: phoneContactPerson,
            email: emailContactPerson,
            address: direccio,
            addressType: typedireccio,
            city: municipi,
            postCode: cp,
            country: country,
            linkSocialNetwork: linkSocialNetwork,
            webPage: linkSocialNetwork,
            socialNetwork: socialNetwork,
            notes: "Notes"
        }

        const newErrors: { name?: string, phone?:string, email?:string } = {};
        if (!name.trim()) {
            newErrors.name = t("common:form.requiredFieldForm");
        }
        if (phoneContactPerson?.trim() && !phoneContactPerson.includes("+34")) {
            newErrors.phone = t("NewClientInputTextPhoneError");
        }
        if (!emailContactPerson.includes("@") && emailContactPerson != '') {
            newErrors.email = t("RequiredFieldEmailForm");
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        

        setErrors({}); // limpiar errores
        setLoading(true);
        try {
            if (isEdit) {
                await updateClient(idClient, body);
                const navigationService = new RouteNavigationService(navigate);
                navigationService.navigateWithMessage('/admin/client', t("client:modal.succesUpdateRegister"));
            } else {
                await saveClient(body);
                const navigationService = new RouteNavigationService(navigate);
                navigationService.navigateWithMessage('/admin/client', t("client:modal.succesCreateRegister"));

            }
        } catch (error) {
            setLoading(false); 
            showAlert({
                message: t("participants.SaveErrorForm"),
                type: 'danger',
                duration: 8000
            });
        }
    };


    return (
        <>
            <Row className="mb-2">
                <Col xs={12} md={8}>
                    <h2>{isEdit ? t("client:edit.editClientTitle") : t("client:new.newClientButtonCreate")}</h2>
                </Col>
                <Col xs={4} md={4} className="text-end">
                    <GenericSaveButton
                        onClick={() => handleSubmit()}
                        onCancelClick={() => navigate('/admin/client')}
                        cancelLabel={isEdit ? t("common:buttons.buttonBack") : t("common:buttons.buttonCancel")}
                        saveLabel={loading ? t("common:buttons.buttonSaveingProgress") : t("common:buttons.buttonSave")}
                        disabled={loading}
                    />
                </Col>
                {isVisible && (
                    <AlertMessage
                        message={alert!.message}
                        type={alert!.type}
                        onClose={hideAlert}
                    />
                )}
            </Row>
            <Row>
                <Col>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col xs={4} md={4}>
                                <Form.Group>
                                    <Form.Label>{t("client:new.newClientInputTextId")} </Form.Label>
                                    <Form.Control
                                        type="text"
                                        disabled
                                        value={idClient}
                                        onChange={(e) => setIdClient(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={8} md={8}>
                                <Form.Group>
                                    <Form.Label>{t("client:new.newClientInputTextName")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={name}
                                        isInvalid={!!errors.name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.name}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '10px' }}>
                            <Col xs={4} md={4}>
                                <Form.Group>
                                    <Form.Label>{t("client:new.newClientInputTextCIF")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={documentNumber}
                                        onChange={(e) => setDocumentNumber(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={8} md={8} style={{ }}>
                                <Form.Group>

                                    <Form.Label>{t("client:new.newClientInputTextSocialReason")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={raoSocial}
                                        onChange={(e) => setRaoSocial(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '40px' }}>
                            <h5>{t("client:new.newClientInputTextTypeAddress")}</h5>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                            <Col xs={4} md={12}>
                                <Form.Label>{t("client:new.newClientInputTextTypeAddress")}</Form.Label>   
                                <Form.Select
                                    value={typedireccio}
                                    onChange={(e) => setTypeDireccio(e.target.value)}
                                >
                                    <option value="">{t("common:selectDefaultText")}</option>
                                    <option value="client1">{t("client:new.newClientInputTextSelectOption1")}</option>
                                </Form.Select>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                            <Col xs={8} md={8} style={{}}>
                                <Form.Group>
                                    <Form.Label>{t("client:new.newClientInputTextAddress")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={direccio}
                                        onChange={(e) => setDireccio(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={4} md={4}>
                                <Form.Group>
                                    <Form.Label>{t("client:new.newClientInputTextCP")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={cp}
                                        onChange={(e) => setCp(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                            <Col xs={4} md={4} style={{ }}>
                                <Form.Group>
                                    <Form.Label>{t("client:new.newClientInputTextCity")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={municipi}
                                        onChange={(e) => setMunicipi(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={4} md={4} style={{ }}>
                                <Form.Group>
                                    <Form.Label>{t("client:new.newClientInputTextState")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={provincia}
                                        onChange={(e) => setProvincia(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={4} md={4} style={{ }}>
                                <Form.Group>
                                    <Form.Label>{t("client:new.newClientInputTextCountry")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={country}
                                        onChange={(e) => setCountry(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '40px' }}>
                            <h5>{t("client:new.newClientInputTextPC")}
                            </h5>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                            <Col xs={4} md={4}>
                                <Form.Group>
                                    <Form.Label>{t("client:new.newClientInputTextPosition")}</Form.Label>
                                    <Form.Select
                                        value={carreg}
                                        onChange={(e) => setCarreg(e.target.value)}
                                    >
                                        <option value="">{t("client:new.newClientInputTextPosition")}</option>
                                        <option value="general">{t("client:new.newClientInputTextSelectOption1")}</option>
                                        </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col xs={8} md={8} style={{ }}>
                                <Form.Group>
                                    <Form.Label>{t("client:new.newClientInputTextNamePerson")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={nameContactPerson}
                                        onChange={(e) => setNameContactPerson(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                            <Col xs={4} md={4}>
                                <Form.Group>
                                    <Form.Label>{t("client:new.newClientInputTextPhone")}</Form.Label>
                                    <Form.Control
                                        type="phone"
                                        value={phoneContactPerson}
                                        isInvalid={!!errors.phone}
                                        onChange={(e) => setPhoneContactPerson(e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.phone}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={8} md={8} style={{ }}>
                                <Form.Group>
                                    <Form.Label>{t("client:new.newClientInputTextEmail")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={emailContactPerson}
                                        isInvalid={!!errors.email}
                                        onChange={(e) => setEmailContactPerson(e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.email}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '40px' }}>
                            <h5>{t("client:new.newClientInputTextSN")}
                            </h5>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                            <Col xs={4} md={4}>
                                <Form.Group>
                                    <Form.Label>{t("client:new.newClientInputTextSN")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={socialNetwork}
                                        onChange={(e) => setSocialNetwork(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={8} md={8} style={{ }}>
                                <Form.Group>
                                    <Form.Label>{t("client:new.newClientInputTextLink")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={linkSocialNetwork}
                                        onChange={(e) => setLinkSocialNetwork(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </>
    );
}
